<template>
    <v-text-field 
        :value="value[schema.name]" 
        @change="$emit('change', $event)"
        @focus="$emit('focus', $event)"
        :label="schema.label" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder || ' '"
        outlined dense hide-details
    />
        <!-- :hide-details="Boolean(schema.compact)"  -->
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {
        hideDetails() {
            if(this.schema.compact)
                return true

            else
                return false
        }
    },

    methods: {
        change(newVal) {
            this.value[this.schema.name] = newVal
            
        }
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// TextControl.vue?b4c42440